// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/intro_screen.sass
// module id = 210
// module chunks = 0